module.exports = __webpack_public_path__ + "static/cabane_alpage-bca22603e7720567455f07b24304a9fb.jpg";